module.exports = __webpack_public_path__ + "img/logo-blue.1b33f4d.svg";